import { getLocale } from "@travily/i18n";
import { getDisplayNames } from "./display-names";

const ISO_LANGUAGE_FORMAT = /^[A-Za-z]{2,3}$/;

/**
 * Localized display name for an ISO 639-1 language code (e.g. `en` → "English").
 * Mirrors {@link localizedCountryName}. Capitalizes the first letter since some
 * locales render language names lowercase.
 */
export function localizedLanguageName(code: string, locale: string = getLocale()): string {
  if (!ISO_LANGUAGE_FORMAT.test(code)) return code;
  const name = getDisplayNames("language", locale).of(code) ?? code;
  return name.charAt(0).toUpperCase() + name.slice(1);
}
